import apiService from "../../api/api.service";
import { WheelPrizesResponse, WheelSpinResponse } from "./wheel.types";

export const fetchWheelPrizes = () => {
  return apiService.get<WheelPrizesResponse>("/wheel/prizes");
};

export const postWheelSpin = () => {
  return apiService.post<WheelSpinResponse>("/wheel/spin");
};
